import { WX_LOGIN_MESSAGE_TYPE } from '@/util/loginAuth'

/** 跨域 iframe 内无法跳转顶层窗口时，通知父页面处理登录 */
export function postWxLoginToParent(code, state) {
  if (window.self === window.top || !code) return false
  window.parent.postMessage(
    {
      type: WX_LOGIN_MESSAGE_TYPE,
      code: String(code),
      state: state != null ? String(state) : '',
    },
    '*'
  )
  return true
}

/** 同源时可跳出 iframe；跨域会抛错 */
export function tryBreakOutOfIframe() {
  try {
    if (window.self !== window.top) {
      window.top.location.replace(window.location.href)
      return true
    }
  } catch (e) {
    /* cross-origin */
  }
  return false
}

export function isWxLoginMessage(data) {
  return !!(data && data.type === WX_LOGIN_MESSAGE_TYPE && data.code)
}



// WEBPACK FOOTER //
// ./src/util/wxLoginBridge.js